import {  JOB_LOAD_FAIL,
    JOB_LOAD_REQUEST,
    JOB_LOAD_SINGLE_FAIL,
    JOB_LOAD_SINGLE_REQUEST,
    JOB_LOAD_SINGLE_SUCCESS,
    JOB_LOAD_SUCCESS } from "../constants/jobConstant"
import axios from 'axios';

const host = "https://jobset-api.onrender.com"

export const jobLoadAction =(pageNumber, keyword='', cat='', location='')=>async(dispatch)=>{
    
    dispatch({type: JOB_LOAD_REQUEST});
    try {
        const {data} = await axios.get(`${host}/api/jobs?pageNumber=${pageNumber}&keyword=${keyword}&cat=${cat}&location=${location}`);
        dispatch({
            type: JOB_LOAD_SUCCESS,
            payload: data
        })
    } catch (error) {
        dispatch({
            type: JOB_LOAD_FAIL,
            payload: error.response.data.error
        });
    }

}

// single job action
export const jobLoadSingleAction = (id) => async (dispatch) => {
    dispatch({ type: JOB_LOAD_SINGLE_REQUEST });
    try {
        const { data } = await axios.get(`${host}/api/job/${id}`);
        dispatch({
            type: JOB_LOAD_SINGLE_SUCCESS,
            payload: data
        });
    } catch (error) {
        dispatch({
            type: JOB_LOAD_SINGLE_FAIL,
            payload: error.response.data.error
        });
    }
}

export const createJobAction =(pageNumber, keyword='', cat='', location='')=>async(dispatch)=>{
    console.log("Job Created");

}